export default "__VITE_ASSET__72732191__"